// ModalContext.js
import React, { createContext, useContext, useState } from "react"

// Create a Modal Context
const ModalContext = createContext()


export const ModalProvider = ({ children }) => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [modalType, setModalType] = useState('')
    const [loading, setLoading] = useState(false)

    // Function to open the modal
    const openModal = (type) => {
        setModalType(type)
        setIsModalOpen(true)
    }

    // Function to close the modal
    const closeModal = () => {
        setIsModalOpen(false)
    }

    return (
        <ModalContext.Provider
            value={{
                isModalOpen,
                modalType,
                openModal,
                closeModal,
                loading,
                setLoading
            }}>
            {children}
        </ModalContext.Provider>
    )
}


// Custom hook to use the ModalContext
export const useModal = () => {
    return useContext(ModalContext)
}